<template>
    <header class="header">
        <app-modal v-if="createCampaign"></app-modal>

        <div v-if="!isPartner" class="tab-selector-wrapper">
            <app-tab-selector
                v-model="tab"
                :data-tabs="tabs"
            ></app-tab-selector>
        </div>

        <div class="search-wrapper">
            <advertising-partner-report-modal v-if="isPartner" />

            <div class="search-buttons-actions">
                <svgicon
                    icon="archive-outline"
                    v-tooltip="'Campanhas Arquivadas'"
                    width="26"
                    height="26"
                    :color="`${showArchived ? getColor(palette.primary) : '#4b4b4b'}`"
                    @click="showArchivedCampaigns"
                ></svgicon>

                <a
                    v-if="!isPartner"
                    :href="redirectToPreLoginUrl"
                    class="pre-login-button"
                    v-tooltip="'Campanha pré-login'"
                >
                    <svg
                        width="20"
                        height="16"
                        viewBox="0 0 20 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M0.00170898 2.5H4.00171V13.5H0.00170898V2.5ZM5.00171 15.5H15.0017V0.5H5.00171V15.5ZM7.00171 2.5H13.0017V13.5H7.00171V2.5ZM16.0017 2.5H20.0017V13.5H16.0017V2.5Z"
                        ></path>
                    </svg>
                </a>
            </div>

            <app-search-bar @enter="filter"></app-search-bar>
        </div>
    </header>
</template>

<script>
import AppSearchBar from "@components/Search";
import AppTabSelector from "@components/TabSelector";
import AdvertisingPartnerReportModal from "@components/modules/advertising/partner/report-modal/AdvertisingPartnerReportModal";
import colors from "@mixins/colors";
import provider from "@mixins/provider";
import EventBus from "@packages/event-bus/index";
import { redirectUtils } from "@packages/util/redirect/redirectUtils";
import AppModal from "./advertising-modal/AdvertisingModal";

export default {
    components: {
        AppSearchBar,
        AppModal,
        AppTabSelector,
        AdvertisingPartnerReportModal,
    },

    data() {
        return {
            tab: "MINE",
        };
    },

    mixins: [provider, colors],

    computed: {
        tabs() {
            const tabs = [
                {
                    label: this.$t("message.campaigns.message.myCampaigns"),
                    value: "MINE",
                },
            ];

            if (this.isEstablishment) {
                tabs.push({
                    label: this.$t(
                        "message.campaigns.message.campaignsOrdering"
                    ),
                    value: "LEVELS",
                });
                tabs.push({
                    label: this.$t("message.campaigns.message.allCampaigns"),
                    value: "ALL_CAMPAIGNS",
                });
            } else if (this.isAnunciante) {
                tabs.push({
                    label: this.$t(
                        "message.campaigns.message.thirdPartyCampaigns"
                    ),
                    value: "THIRD_PARTY",
                });
            }

            return tabs;
        },
        isEstablishment() {
            return this.$store.state.users.user.tipo === "ESTABELECIMENTO";
        },
        isAnunciante() {
            return this.$store.state.users.user.tipo === "ANUNCIANTE";
        },
        permissions() {
            return this.$store.state.users.user.permissions;
        },
        createCampaignPermissionEstablishment() {
            return this.permissions.find((x) => x === "CREATE_CAMPAIGN")
                ? true
                : false;
        },
        createCampaign() {
            return this.isPartner
                ? true
                : this.createCampaignPermissionEstablishment;
        },
        showArchived: {
            get() {
                return this.$store.state.advertising.filters.archived;
            },
            set() {
                this.showArchived();
            },
        },
        isPartner() {
            return (
                this.$store.state.users.user &&
                this.$store.state.users.user.tipo === "PARCEIRO"
            );
        },
        redirectToPreLoginUrl() {
            return redirectUtils.mountUrl('/new/estabelecimento/campanhas/pre-login');
        },
    },

    methods: {
        filter(value) {
            this.$store.commit("ADVERTISING_SET_FILTER", {
                key: "search",
                value,
            });
            EventBus.$emit("GO_TO_FIRST_PAGE");
        },
        showArchivedCampaigns() {
            this.$store.commit("ADVERTISING_SET_FILTER", {
                key: "archived",
                value: !this.$store.state.advertising.filters.archived,
            });
        },
    },

    watch: {
        tab(tab) {
            const isLevels = tab === "LEVELS";
            const isAllCampaigns = tab === "ALL_CAMPAIGNS";

            this.$store.commit("ADVERTISING_SET_FILTER", {
                key: "isLevels",
                value: isLevels,
            });

            this.$store.commit("ADVERTISING_SET_ALL_CAMPAIGNS", isAllCampaigns);

            EventBus.$emit("SEARCH_RESET");
            this.$store.commit("ADVERTISING_SET_FILTER", {
                key: "search",
                value: "",
            });
            EventBus.$emit("GO_TO_FIRST_PAGE");
        },
    },

    destroyed() {
        this.$store.commit("ADVERTISING_SET_FILTER", {
            key: "isLevels",
            value: false,
        });

        this.$store.commit("ADVERTISING_SET_ALL_CAMPAIGNS", false);

        this.$store.commit("ADVERTISING_SET_FILTER", {
            key: "search",
            value: "",
        });
    },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 50px;

    .tab-selector-wrapper {
        width: 400px;
    }

    .search-buttons-actions {
        display: flex;
        align-items: center;
        gap: 16px;
    }

    .search-wrapper {
        display: flex;
        gap: 22px;
        align-items: center;

        svg {
            cursor: pointer;
            outline: none;
            fill: red;

            path {
                fill: currentColor;
            }

            &.active {
                color: $blue-primary;
            }
        }

        ::v-deep .v-dialog__activator {
            display: flex;
        }
    }

    > * {
        &:last-child {
            flex-grow: 0;
        }
    }

    .pre-login-button {
        color: #4b4b4b;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>
